module.exports = __webpack_public_path__ + "img/qbzh.8ba4cb71.png";